<main class="bg-skin-col w-100 w-100-mob">
  <app-heading></app-heading>
  <div class="d-flex justify-content-center pt-17">
    <div class="text-center">
      <div class="ps-10 ps-2rem pe-11 pe-2rem">
        <h1 class="fw-bold fw-medium-mob bg-green lh-base font-outfit col-blue ls-01em rounded-3 mb-0">Need Help?</h1>
      </div>
      <p class="fs-40px lh-sm lh-base-mob font-outfit col-blue fw-semibold ls-01em">We’re here for you!</p>
    </div>
  </div>
  <div class="d-flex justify-content-center mt-7 mt-2-mob pb-12">
    <div class="row justify-content-center">
      <div class="col-lg-5 col-10 mb-4 d-flex justify-content-center">
        <div class="bg-white rounded-4 p-4">
          <iframe class="map-iframe rounded-3"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3020.7771357972833!2d43.83379917672725!3d40.78891347138218!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4041fb650487228d%3A0x87df517deccda117!2sITSpace%20LLC!5e0!3m2!1sen!2sam!4v1744710999085!5m2!1sen!2sam"
                  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          <br>
          <div class="contact-row mb-2 mt-3 me-3 d-inline-block">
            <img src="/assets/images/contact-us/location-icon.png" alt="location">
          </div>
          <h4 class="font-outfit col-blue fw-normal d-inline-block">Shirakatsi 104, Gyumri, Armenia</h4>
          <br>
          <div class="contact-row me-3 d-inline-block">
            <img src="/assets/images/contact-us/phone-icon.png" alt="phone">
          </div>
          <h4 class="font-outfit col-blue fw-normal d-inline-block">+374 93 880 148</h4>
          <br>
          <div class="contact-row me-3 d-inline-block">
            <img src="/assets/images/contact-us/mail-icon.png" alt="mail">
          </div>
          <h4 class="font-outfit col-blue fw-normal d-inline-block">itquiz@gmail.com</h4>
        </div>
      </div>
      <div class="col-lg-5 col-10 ms-14 ms-14-mob d-flex justify-content-center mt-3-mob">
        <form [formGroup]="contactForm" (ngSubmit)="onSubmit()" class="w-600">
          <h5 class="col-blue font-outfit mb-2">User Name</h5>
          <input type="text" formControlName="username" class="input-custom w-100 pb-4 rounded-3"/>
          <div class="validation"
               *ngIf="contactForm.get('username')!.errors?.['required'] && (contactForm.get('username')!.touched || contactForm.get('username')!.dirty)">
            Username cannot be blank.
          </div>
          <h5 class="col-blue font-outfit mt-3 mb-2">Email</h5>
          <input type="email" formControlName="email" class="input-custom w-100 pb-4 rounded-3"/>
          <div class="validation"
               *ngIf="contactForm.get('email')!.errors?.['required'] && (contactForm.get('email')!.touched || contactForm.get('email')!.dirty)">
            Email address cannot be blank.
          </div>
          <div class="validation"
               *ngIf="contactForm.get('email')!.hasError('email') && (contactForm.get('email')!.touched || contactForm.get('email')?.dirty)">
            Please enter a valid email address.
          </div>
          <h5 class="col-blue font-outfit mt-3 mb-2">Phone Number</h5>
          <input type="text" formControlName="phoneNumber" class="input-custom w-100 pb-4 rounded-3"/>
          <div class="validation"
               *ngIf="contactForm.get('phoneNumber')!.errors?.['required'] && (contactForm.get('phoneNumber')!.touched || contactForm.get('phoneNumber')!.dirty)">
            Phone number cannot be blank.
          </div>
          <h5 class="col-blue font-outfit mt-3 mb-2">
            Company <span class="col-grey">(if applicable)</span>
          </h5>
          <input type="text" formControlName="companyName" class="input-custom w-100 pb-4 rounded-3"/>
          <h5 class="col-blue font-outfit mt-3 mb-2">Message</h5>
          <textarea formControlName="message" class="textarea-custom w-100 pb-7 rounded-3"></textarea>
          <div class="validation"
               *ngIf="contactForm.get('message')!.errors?.['required'] && (contactForm.get('message')!.touched || contactForm.get('message')!.dirty)">
            Message cannot be blank.
          </div>
          <button type="submit" class="bg-purple border-0 rounded-5 mt-4 pt-2 pb-2 d-flex justify-content-center align-items-center w-100">
            <h4 class="fw-medium font-outfit col-blue mb-0">Send</h4>
          </button>
        </form>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</main>
